/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from 'prop-types';
import React from 'react';
import { Link } from '../Link';
import './style.css';

import { useNavigate } from 'react-router-dom';

export const Breadcrumb = ({
    breadcrumbText = 'Home',
    breadcrumb,
    className,
    linkText = 'Materialien',
}) => {
    const navigate = useNavigate();

    return (
        <div className={`breadcrumb ${className}`}>
            <div className={`frame-5 ${breadcrumb}`}>
                <Link
                    className="link-instance"
                    text="Home"
                    onClick={() => {
                        navigate('/');
                    }}
                />

                {['one-level', 'two-level'].includes(breadcrumb) && (
                    <>
                        <div className="text-wrapper-2">/</div>
                        <Link
                            className="link-instance"
                            text={
                                breadcrumb === 'one-level'
                                    ? linkText
                                    : 'Materialien'
                            }
                            onClick={() => {
                                navigate('/directory');
                            }}
                        />
                    </>
                )}

                {breadcrumb === 'two-level' && (
                    <>
                        <div className="text-wrapper-2">/</div>
                        <Link className="link-instance" text={breadcrumbText} />
                    </>
                )}
            </div>
        </div>
    );
};

Breadcrumb.propTypes = {
    breadcrumbText: PropTypes.string,
    breadcrumb: PropTypes.oneOf(['two-level', 'zero-level', 'one-level']),
    linkText: PropTypes.string,
};
